$(document).ready(function() {
  // Listen for changes to the content of the "preorder" span
   $('#preorder').text('Pre Order');
  console.log("test2");
  $('#preorder').bind('DOMSubtreeModified', function() {
    // Set the content of the "preorder" span to "Pre Order"
    $(this).text('Pre Order');
    console.log("test");
  });
 


});

  document.addEventListener('DOMContentLoaded', function() {
fetch('/browsing_context_suggestions.json')
  .then(response => response.json())
  .then(data => {
    const countryCode = data?.detected_values?.country?.handle; // Extract the country code
    console.log("you are coming from: ", countryCode);
    if (countryCode !== 'GB') { //GB for UK, and SA for Saudi Arabia
      $(".freeshipping").hide();
    }
    });
    });


 $(document).ready(function(){
      // Function to change content of span with class "pre_order"
      function updatePreOrderText() {
        $(".pre_order").text("PRE-ORDER");
      }

      // Initial content update
      updatePreOrderText();

      // Event listener for changes in text
      $(document).on('DOMSubtreeModified', '.pre_order', function(){
        // Check if parent ".btn-cart" has ".disabled" class
        if (!$('.pre_order').closest('.btn-cart').hasClass('disabled')) {
          // Reapply the function if text is modified and parent is not disabled
          updatePreOrderText();
        }
      });
    });